import { nanoid } from 'nanoid';

export const MAX_QUESTION_ADDED = 10;
export const EmojiSize = 20;
export const MAX_CARD_HEIGHT = 700;
export const DUMMY_STUD_USERID = 'TTkHCaTFQacA8Jfd864OtFbKGcn1';
export const DUMMY_TECH_USERID = 'QAWNI1wd21fIJPUwWPAO9uu9WRZ2';
export const NO_IMAGE_URL =
  'https://gravatar.com/avatar/4b24fa016bc5cc6aaa49246d8a401917?s=400&d=mp&r=x';
export const API_LIMIT_DATA = 5;

export const SEVEN_DAY_COLOR = {
  monday: '#9400D3',
  tuesday: '#4B0082',
  wednesday: '#0000FF',
  thursday: '#00FF00',
  friday: '#FFFF00',
  saturday: '#FF7F00',
  sunday: '#FF0000'
};

export const USER_AVATAR = [
  'https://cms.fainlearn.com/uploads/small_female_avatar1_5fb7845f0a.png',
  'https://cms.fainlearn.com/uploads/small_male_avatar1_c6181523e1.png',
  'https://cms.fainlearn.com/uploads/small_male_avatar2_c555ca3d07.png',
  'https://cms.fainlearn.com/uploads/small_female_avatar3_321efd4758.png',
  'https://cms.fainlearn.com/uploads/small_female_avatar2_dcc8f32285.png',
  'https://cms.fainlearn.com/uploads/small_male_avatar3_ca270c4a34.png'
];

export const POLL_DURATION = [
  { value: '1 day', label: '1 Day' },
  { value: '3 day', label: '3 Days' },
  { value: '1 week', label: '1 Week' },
  { value: '2 week', label: '2 Weeks' }
];

export const searchFilter = ['isDiscoverable = true'];

export const teacherClassTopBarOptions = [
  {
    title: 'Overview',
    index: 0
  },
  {
    title: 'Resources',
    index: 1
  },
  {
    title: 'Test',
    index: 2
  },
  {
    title: 'Student',
    index: 3
  },
  {
    title: 'Chat',
    index: 4
  },
  {
    title: 'Assignment',
    index: 5
  },
  {
    title: 'Attendance',
    index: 6
  }
];

export const studentClassTopBarOptions = [
  {
    title: 'Overview',
    index: 0
  },
  {
    title: 'Resources',
    index: 1
  },
  {
    title: 'Test',
    index: 2
  },
  {
    title: 'Chat',
    index: 4
  },
  {
    title: 'Assignment',
    index: 5
  }
];

export const teacherTestBar = [
  {
    id: 1,
    title: 'Upcoming'
  },
  {
    id: 2,
    title: 'Previous'
  }
];

export const STUDENT_TEST_BAR = [
  {
    id: 1,
    title: 'Upcoming'
  },
  {
    id: 2,
    title: 'Previous'
  }
];

export const STUDENT_CHART_OPTIONS = [
  {
    label: 'Monthly',
    value: 'monthly'
  },
  {
    label: 'Quatarly',
    value: 'quatarly'
  },
  {
    label: 'Yearly',
    value: 'yearly'
  }
];

export const STUDENT_EXAM = {
  id: 1,
  subject: 'Basic Mathematics',
  percentage: 89,
  testCount: 10,
  cgpa: 7.92,
  totalMark: 100
};

export const STUDENTS_LATEST_EXAM = [
  {
    id: 1,
    subject: 'English',
    percentage: 89,
    testCount: 10,
    cgpa: 7.92,
    totalMark: 100
  },
  {
    id: 2,
    subject: 'Art & Painting',
    percentage: 89,
    testCount: 10,
    cgpa: 7.92,
    totalMark: 100
  }
];

export const PROMOTE_DATA = {
  id: 1,
  name: 'John Doe',
  mail: 'johndoe@gmail.com',
  number: '9123456789',
  joinedAt: new Date(),
  location: 'Bangalore, India',
  totalExp: '8+',
  teachingHour: 122,
  subjects: ['English', 'Math', 'Art', 'Painting'],
  imageUrl: 'https://gravatar.com/avatar/4cd996b5b4bb977b7a6b2103605b4400?s=800&d=identicon&r=x'
};

export const TEST_OBJ = {
  id: nanoid(),
  testName: '',
  testType: 'WRITE',
  description: '',
  marking: {
    correct: 0,
    incorrect: 0,
    total: 0
  },
  duration: 0,
  startDate: new Date(),
  startTime: new Date(),
  createdAt: new Date(),
  isPracticeTest: false,
  isPublishResult: false,
  isRandomize: false
};

export const QUESTIONS_OBJ = [
  {
    _id: nanoid(),
    name: '',
    isError: false,
    isAnsNotSelected: true,
    options: [
      {
        _id: nanoid(),
        value: '',
        isAnswer: false,
        isError: false
      },
      {
        _id: nanoid(),
        value: '',
        isAnswer: false,
        isError: false
      }
    ]
  }
];

export const OPTIONS_LABEL = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z'
];

export const flagsWithCode = [{ id: 1, flag: '🇮🇳', code: '+91' }];

export const FEATURED_CLASSES = [
  {
    id: 1,
    name: 'Tesla',
    image: 'https://upload.wikimedia.org/wikipedia/commons/e/e8/Tesla_logo.png'
  },
  {
    id: 1,
    name: 'Chemistry',
    image: 'https://i.pinimg.com/originals/54/1f/f2/541ff2e5ab104a1be4373c3f60120b09.png'
  },
  {
    id: 1,
    name: 'Maths',
    image:
      'https://static.vecteezy.com/system/resources/previews/005/115/826/original/student-math-logo-template-this-design-use-calculator-symbol-suitable-for-education-free-vector.jpg'
  },
  {
    id: 1,
    name: 'Sceience',
    image: 'https://www.kindpng.com/picc/m/78-786173_computer-science-logo-png-transparent-png.png'
  }
];
